<template>
    <c-input-element :label="label" :helptext="helptext" :class="[{ 'c-form-element--horizontal' : horizontal, 'c-form-element--row' : row}]" :name="$attrs.name">
        <input v-bind="$attrs" v-model="value" ref="element" />
        <div v-if="after" class="c-form-element__after">/ {{after}}</div>
    </c-input-element>
</template>

<script>
import Input from '@mixins/Input';

export default {
    name: 'form-input',
    inheritAttrs: false,
    mixins: [Input],
    props: {
        after: {
            
        },
        row: {
            type: Boolean,
            defeault: false
        },
        validation: Function,
    },
    mounted() {

        if (this.validation) {
            this.$refs.element.validation = this.validation;
        }
    }
}
</script>